/* ETA hero CLS guard — v3, 2026-06-09.
   The spotlight hero's typewriter/crossfade rotation changes each display
   line's text, so line boxes grew/shrank/wrapped every cycle and shifted
   their siblings — recurring layout shifts of 0.02–0.06 per rotation tick.

   Strategy: pre-measure, then pin.
   1. Read the section's own [data-eta-hero-taglines] JSON, render every
      tagline in a hidden clone of the display, and record the max width and
      height each line slot (l1/l2/l3) ever needs, plus the display's max
      total height.
   2. Pin those as min-width/min-height on the real elements BEFORE the
      first rotation tick. Every box keeps a constant rect; text changes
      become paint-only. A small caret allowance is added per line so the
      typewriter caret never widens a box past its pin.
   3. Ratchet safety net (never shrink) + full re-measure on resize.

   To undo: delete this file and its <script> include in layout/theme.liquid. */
(function () {
  'use strict';

  // Keep an emptied rotating line's box height; reserve one line for the tag.
  var style = document.createElement('style');
  style.textContent =
    '[data-eta-hero] .eta-hero__line{min-height:0.88em;}' +
    '[data-eta-hero] .eta-hero__tag{min-height:1.5em;}';
  document.head.appendChild(style);

  var SLOTS = ['l1', 'l2', 'l3'];

  function premeasure(root, displayEl) {
    try {
      var script = root.querySelector('[data-eta-hero-taglines]');
      if (!script || !displayEl || !displayEl.parentNode) return;
      var taglines = JSON.parse(script.textContent || '[]');
      if (!Array.isArray(taglines) || taglines.length < 2) return;

      var clone = displayEl.cloneNode(true);
      clone.style.position = 'absolute';
      clone.style.visibility = 'hidden';
      clone.style.pointerEvents = 'none';
      clone.style.width = displayEl.getBoundingClientRect().width + 'px';
      clone.style.minHeight = '0';
      clone.classList.add('is-revealed');
      displayEl.parentNode.appendChild(clone);

      var cloneSlots = {}, realSlots = {}, dims = {};
      SLOTS.forEach(function (k) {
        cloneSlots[k] = clone.querySelector('[data-eta-rotate-slot="' + k + '"]');
        realSlots[k] = displayEl.querySelector('[data-eta-rotate-slot="' + k + '"]');
        if (cloneSlots[k]) { cloneSlots[k].style.minWidth = '0'; cloneSlots[k].style.minHeight = '0'; }
        dims[k] = { w: 0, h: 0 };
      });

      var maxTotalH = 0;
      taglines.forEach(function (t) {
        SLOTS.forEach(function (k) {
          if (cloneSlots[k]) cloneSlots[k].textContent = (t && t[k]) || '';
        });
        var totalH = clone.offsetHeight;
        if (totalH > maxTotalH) maxTotalH = totalH;
        SLOTS.forEach(function (k) {
          var el = cloneSlots[k];
          if (!el) return;
          var r = el.getBoundingClientRect();
          if (r.width > dims[k].w) dims[k].w = r.width;
          if (r.height > dims[k].h) dims[k].h = r.height;
        });
      });
      clone.parentNode.removeChild(clone);

      SLOTS.forEach(function (k) {
        var el = realSlots[k];
        if (!el || !dims[k].w) return;
        var fs = parseFloat(getComputedStyle(el).fontSize) || 16;
        var caretAllowance = fs * 0.12; // typewriter caret width
        var wPin = Math.ceil(dims[k].w + caretAllowance);
        var hPin = Math.ceil(dims[k].h);
        if (wPin > (parseFloat(el.style.minWidth) || 0)) el.style.minWidth = wPin + 'px';
        if (hPin > (parseFloat(el.style.minHeight) || 0)) el.style.minHeight = hPin + 'px';
      });
      if (maxTotalH > (parseFloat(displayEl.style.minHeight) || 0)) {
        displayEl.style.minHeight = Math.ceil(maxTotalH) + 'px';
      }
    } catch (e) { /* never break the hero over a guard */ }
  }

  function guard(root) {
    if (!root || root.__etaClsGuard) return;
    root.__etaClsGuard = true;
    if (root.dataset.etaRotate !== '1') return; // no rotation, no shifts
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var overlap = root.querySelector('.eta-hero__overlap');
    var display = root.querySelector('.eta-hero__display');
    var tag = root.querySelector('.eta-hero__tag');

    function ratchet(el) {
      if (!el) return;
      var h = el.getBoundingClientRect().height;
      var cur = parseFloat(el.style.minHeight) || 0;
      if (h > cur + 0.5) el.style.minHeight = h + 'px';
    }
    function lock() {
      premeasure(root, display);
      ratchet(overlap); ratchet(display); ratchet(tag);
    }
    function relock() {
      [overlap, display, tag].forEach(function (el) { if (el) el.style.minHeight = ''; });
      if (display) {
        SLOTS.forEach(function (k) {
          var el = display.querySelector('[data-eta-rotate-slot="' + k + '"]');
          if (el) { el.style.minWidth = ''; el.style.minHeight = ''; }
        });
      }
      lock();
    }

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(lock);
    window.addEventListener('load', lock);
    lock();
    setInterval(function () {
      if (!document.hidden) { ratchet(overlap); ratchet(display); ratchet(tag); }
    }, 1000);

    var rT;
    window.addEventListener('resize', function () {
      clearTimeout(rT);
      rT = setTimeout(relock, 150);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-eta-hero]').forEach(guard);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
